import React, { useState, useEffect } from 'react';
import { useUserProfile } from '../helper/UserProfile';

const Courses = () => {
    const [accountId, setAccountId] = useState("");

    const { profile } = useUserProfile();

    useEffect(() => {
        
    })


    

  return (
    <div>
        <div className="dashboard-body">
            <h2>COURSES</h2>
            <p>Here are the list of 1664 Training Solutions courses that are looking for an instructor.</p>
            

        </div>
    </div>
  )
}

export default Courses